import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Certificate2Service} from '../services/certificate2.service';
import {ContextService} from '../services/context.service';
import {SubscriptionsService} from 'src/app/services/subscriptions.service';
import {EnrollmentService} from '../services/enrollment.service';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {EventService} from '../services/event.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {CertificatesSpeakers_v2DialogComponent} from './dialogs/certificates-speakers_v2-dialog/certificates-speakers_v2-dialog.component';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AgendaService} from '../services/agenda.service';

@Component({
  selector: 'app-certificates-speakers_v2',
  templateUrl: './certificates-speakers_v2.component.html',
  styleUrls: [ './certificates-speakers_v2.component.scss' ]
})
export class CertificatesSpeakers_v2Component implements OnInit {

  public isCongress = false;
  public context_id: any;
  public title: any;

  public subscriptionDataSource: MatTableDataSource<any>
  public displayedCertificateColumns: string[] = [ 'icon', 'member_name', 'product_name', 'view', 'selected' ];

  public waiting: any;

  //public arrayCertificate: any[] = []
  public eventsWithCertificatesInContext: any[] = [];
  public selectedEvent: any = null;

  public arrayEvents: any[] = []

  public enrollments: any = [];

  public master: any;
  public event: any;

  public displayedCertificateStaffColumns: string[] = [ 'icon', 'member_name', 'viewer', 'selected' ];
  public staffDataSource: MatTableDataSource<any>
  //
  public staffs: any[] = [];

  constructor (
    public _agendaService: AgendaService,
    public _eventService: EventService,
    private _activeRoute: ActivatedRoute,
    public _certificateService: Certificate2Service,
    private _contextService: ContextService,
    public _subscriptionsService: SubscriptionsService,
    private _enrollmentService: EnrollmentService,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _dialog: MatDialog,

  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.isCongress = params[ 'isCongress' ] === 'true';
      this.context_id = params[ 'uid' ];
      // console.log("context_id: " + this.context_id)
      this.selectContext()
    })
  }

  applyFilter (filterValue: string) {
    this.subscriptionDataSource.filter = filterValue.trim().toLowerCase();
  }

  async _selectContext () {
    const waiting = this._spinnerService.show();

    if (this.isCongress) {
      this.master = await this._contextService.getMasterEvent(this.context_id);
      this.title = this.master.name;
      this.eventsWithCertificatesInContext = await this._contextService.getEventsWithCertificatesInContext(this.context_id)
    } else {
      this.event = await this._contextService.getEvent(this.context_id);
      this.title = this.event.name;
      this.eventsWithCertificatesInContext.push({"id": this.event.id, "name": this.event.name})
    }

    this.arrayEvents = await this._contextService.selectProductsByEvents(this.eventsWithCertificatesInContext);

    console.log("this.arrayEvents: " + JSON.stringify(this.arrayEvents))
    waiting.close();
  }

  async selectContext () {

    this.waiting = this._spinnerService.show();

    if (this.isCongress) {
      this.master = await this._contextService.getMasterEvent(this.context_id);
      this.title = this.master.name;
      this.eventsWithCertificatesInContext = await this._contextService.getEventsWithCertificatesInContext(this.context_id)
    } else {
      this.event = await this._contextService.getEvent(this.context_id);
      this.title = this.event.name;
      this.eventsWithCertificatesInContext.push({"id": this.event.id, "name": this.event.name})
    }

    this.arrayEvents = await this._contextService.selectProductsByEvents(this.eventsWithCertificatesInContext);

    // console.log("this.arrayEvents: " + JSON.stringify(this.arrayEvents))

    this.waiting.close();
    //

    /*
    const agenda = await this._agendaService.selectByEvents(this.events);
    this.enrollments = await this._enrollmentService.selectByEvents(this.events)
    */

    // console.log("enrollments: " +  JSON.stringify(this.enrollments))
    // console.log("---------------------------------")
    // console.log(JSON.stringify(this.enrollments))

    // this.processStaff(agenda, this.enrollments);

  }

  async eventChange (param: any) {
    // console.log("eventChange: " + JSON.stringify(param))
    this.waiting = this._spinnerService.show();

    this.selectedEvent = param;
    const agenda = await this._agendaService.selectByOneEvent(param.id);
    // console.log("agenda: " + JSON.stringify(agenda))
    this.enrollments = await this._enrollmentService.selectByOneEvent(param.id);
    // console.log("enrollments: " + JSON.stringify(this.enrollments))

    this.processStaff(agenda, this.enrollments);
  }

  async processStaff (agenda: any[], enrollments: any[]) {

    this.staffs = [];

    agenda.forEach((item: any) => {
      let enroll = enrollments.find((e) => {
        if (item.topic_id) {
          return e.member_id == item.member_id
            && e.event_id == item.event_id
            && e.activity_id == item.activity_id
            && e.topic_id == item.topic_id
        } else {
          return e.member_id == item.member_id
            && e.event_id == item.event_id
            && e.activity_id == item.activity_id
        }
      })

      let selected: boolean = false;
      let certificate_url: string = "";

      if (enroll) {
        selected = true;
        // console.log("certificate_url: " + enroll.certificate_url)
        certificate_url = enroll.certificate_url
      }

      let dt: any = item.day_date
      let dtFull = new Date(dt.seconds * 1000)

      this.staffs.push({
        "enroll_id": enroll ? enroll.id : '',
        "event_id": item.event_id,
        "event_name": item.event_name,
        "day_id": item.day_id,
        "day_name": item.day_name,
        "day_date": dtFull,
        "activity_id": item.activity_id,
        "activity_name": item.activity_name,
        "topic_id": item.topic_id ? item.topic_id : "",
        "topic_name": item.topic_name,
        "member_id": item.member_id,
        "member_name": item.member_name,
        "type": item.role_name,
        "selected": selected,
        "certificate_url": certificate_url
      })

    })

    this.staffs.sort(this.compareMembers)

    // console.log("staffs: " + JSON.stringify(this.staffs))
    //
    this.staffDataSource = new MatTableDataSource(this.staffs)
    this.waiting.close();
  }

  compareMembers (a, b) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  toggleCheckStaff (flag) {
    this.staffDataSource.data.forEach((item) => {
      item.selected = flag;
    })
  }

  async processSubscription (subscriptions: any[], enrollments: any[]) {
    //console.log("subscriptions: " + JSON.stringify(subscriptions))
    const arrayCertificate: any[] = []

    subscriptions.forEach((subscription) => {

      let enroll = enrollments.find((e) => {
        return e.member_id == subscription.member_id && e.type == 'participante';
      })

      let selected: boolean = false;
      let certificateURL: any;
      if (enroll) {
        //console.log("enroll: " + JSON.stringify(enroll))
        selected = true
        certificateURL = enroll.certificate_url.length > 0 ? enroll.certificate_url : null
      }

      arrayCertificate.push({
        "enroll_id": enroll ? enroll.id : '',
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "products": subscription.product_id,
        "member_name": subscription.member_name,
        "member_email": subscription.member_email,
        "member_id": subscription.member_id,
        "topic_id": subscription.topic_id || '',
        "topic_name": subscription.topic_name || '',
        "text1": subscription.topic_text1 || '',
        "text2": subscription.topic_text2 || '',
        "text3": subscription.topic_text3 || '',
        "certificate_url": certificateURL,
        "selected": selected
      });

    })

    return arrayCertificate;
  }

  openCertificateConfigDialog () {
    let data = {};

    if (this.isCongress) {
      data = {
        //"id": this.master.id,
        //"name": this.master.name,
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "isCongress": this.isCongress,
        // "products": this.selectedEvent.products,
      }
    } else {
      data = {
        //"id": this.event.id,
        //"name": this.event.name,
        "event_id": this.selectedEvent.id,
        "event_name": this.selectedEvent.name,
        "isCongress": this.isCongress,
        // "products": this.selectedEvent.products,
      }
    }

    let dialogRef = this._dialog.open(CertificatesSpeakers_v2DialogComponent, {
      width: '920px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];

        if (actionType == 'ok') {

          
          const form: any = response[ 1 ];
          const objectImage: string = response[ 2 ];
          const formData = form.getRawValue();
          
          /*
          console.log("data: " + JSON.stringify(data));
          console.log("objectImage: " + objectImage);
          console.log("formData: " + JSON.stringify(formData));
          */

          const entity = {
            "id": formData.event_id,
            "name": formData.event_name,
            "isCongress": formData.isCongress,
            "staff_role": formData.staff_role,
            "staff_qrCode": formData.staff_qrCode,
            "staff_image_url": formData.staff_image_url
          }

          console.log("entity: " + JSON.stringify(entity));
         
          
          await this._certificateService.updateConfig(entity)
            .then(async () => {

              if (objectImage) {
                await this._certificateService.uploadImage(objectImage, entity.id, "staff_")
                  .then(() => {
                    // console.log("uploadImage result: " + JSON.stringify(result))
                  })
                  .catch(() => {
                    console.log("uploadImage error: ");
                  })
              }

            })
          

        }


      })
  }

  async updateSubscriptionEnrollments () {
    let array = this.subscriptionDataSource.data

    for (const item of array) {
      let existInEnrollments = this.enrollments.find((e: any) => {
        return e.member_id == item.member_id && e.type == 'participante';
      })

      if (item.selected && !existInEnrollments) {

        // insert in enrollments
        let enrollment: any = {
          created: new Date(),
          finished: true,
          type: "participante",
          certificate_url: "",

          member_id: item.member_id,
          member_name: item.member_name,

          event_id: item.event_id,
          event_name: item.event_name,
          topic_id: item.topic_id,
          topic_name: item.topic_name,
          topic_text1: item.text1 || '',
          topic_text2: item.text2 || '',
          topic_text3: item.text3 || '',
        }

        // console.log("insert: " + JSON.stringify(enrollment))

        await this._enrollmentService.insert(enrollment)
          .then(async (e) => {
            // this._snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((error) => {
            // console.log("insert erro: " + JSON.stringify(error))
            // this._snackBar.openSnackBar("Erro", '', 'error');
          })

      } else if (!item.selected && existInEnrollments) {

        //  console.log("remove: " + JSON.stringify(item))

        await this._enrollmentService.remove(item.enroll_id)
          .then(
            async () => {
              console.log("removed: " + item.enroll_id)
            }
          )
          .catch(
            (error) => {console.log("delete enroll error: " + error.message)}
          )

      }

    }

    // console.log("this.eventChange")
    this.eventChange(this.selectedEvent)
  }


  removeEnroll (element) {
    // console.log(element.enroll_id)

    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.event_name + "<br>" + element.member_name + "<br><br>Excluir este certificado?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._enrollmentService.remove(element.enroll_id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            () => {console.log("delete enroll error: ")}
          )
      }
    })
  }

  toggleCheckUsers (flag) {
    this.subscriptionDataSource.data.forEach((item) => {
      item.selected = flag;
    })
  }

}
